import Axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  addBank: {
    isSuccess: false,
    isError: false,
    isFetching: false,
    message: "",
  },
};

export const addBankToDb = createAsyncThunk(
  "addBankToDb/addBankSlice",
  async (bank) => {
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    // console.log("in addBankSlice", holiday);
    const url = `${process.env.REACT_APP_NODE_URL}/api/addBank-data`;
    return await Axios.post(url, bank, config).then((response) => {
      return response.data;
    });
  }
);
const addBankSlice = createSlice({
  name: "addBank",
  initialState,
  reducers: {
    clearaddBank: (state) => {
      state.addBank.isError = false;
      state.addBank.isSuccess = false;
      state.addBank.isFetching = false;
      state.addBank.message = "";
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addBankToDb.pending, (state) => {
      state.addBank.isFetching = true;
    });
    builder.addCase(addBankToDb.fulfilled, (state, action) => {
      state.addBank.isFetching = false;
      state.addBank.isSuccess = true;
      state.addBank.message = action.payload;
    });
    builder.addCase(addBankToDb.rejected, (state, action) => {
      state.addBank.isFetching = false;
      state.addBank.isError = true;
    });
  },
});
export const { clearaddBank } = addBankSlice.actions;
export default addBankSlice.reducer;
